import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServicesHeader from './components/ServicesHeader';
import ServiceDetail from './components/ServiceDetail';
import SolarSection from './components/SolarSection';
import HowItWorks from './components/HowItWorks';
import ServicesCTA from './components/ServicesCTA';

const serviceData = [
  {
    number: '01',
    title: 'AI Lead Capture',
    description:
      'Never let another lead slip through. Our AI automatically answers inbound calls, captures web form submissions, and qualifies prospects in real time—24 hours a day, 365 days a year. Every opportunity is logged, routed, and ready for your team before they even pick up the phone.',
    features: [
      { text: 'AI call answering & transcription' },
      { text: 'SMS lead capture & opt-in flows' },
      { text: 'Instant lead qualification scoring' },
      { text: 'No missed opportunities, ever' },
    ],
    icon: 'ri-phone-find-line',
    reverse: false,
    bgClass: 'bg-white',
    imageUrl:
      'https://public.readdy.ai/ai/img_res/8d5a2a3b077ffe47089366add5ebe91e.jpg',
    imageAlt: 'AI Lead Capture automation system for home service businesses',
  },
  {
    number: '02',
    title: 'Smart Scheduling & Dispatch',
    description:
      'Eliminate the back-and-forth of manual booking. Our scheduling system integrates with your calendar, lets customers book instantly, and automatically coordinates dispatch—so your techs are always where they need to be, on time, every time.',
    features: [
      { text: 'Real-time online booking integration' },
      { text: 'Two-way calendar sync' },
      { text: 'Automated appointment reminders' },
      { text: 'Intelligent dispatch coordination' },
    ],
    icon: 'ri-calendar-2-line',
    reverse: true,
    bgClass: 'bg-[#F8FAFC]',
    imageUrl:
      'https://readdy.ai/api/search-image?query=digital%20calendar%20scheduling%20interface%20displayed%20on%20a%20clean%20computer%20monitor%2C%20appointment%20booking%20and%20dispatch%20management%20software%20for%20field%20service%20company%2C%20organized%20schedule%20with%20technician%20assignments%2C%20modern%20clean%20office%20environment&width=700&height=500&seq=svc-sched-01&orientation=landscape',
    imageAlt: 'Smart scheduling and dispatch automation for HVAC and plumbing',
  },
  {
    number: '03',
    title: 'Automated Follow-Up',
    description:
      'Most businesses send an estimate and hope for the best. Our system does the work for you—sending timed follow-up messages, re-engaging cold leads, and requesting reviews automatically. Nothing falls through the cracks.',
    features: [
      { text: 'Missed call text-back within seconds' },
      { text: 'Multi-step estimate follow-up sequences' },
      { text: 'Re-engagement campaigns for cold leads' },
      { text: 'Automated review request messages' },
    ],
    icon: 'ri-mail-send-line',
    reverse: false,
    bgClass: 'bg-white',
    imageUrl:
      'https://readdy.ai/api/search-image?query=business%20person%20reviewing%20automated%20message%20sequences%20on%20a%20laptop%20screen%2C%20CRM%20follow-up%20workflow%20software%20interface%2C%20clean%20professional%20office%20environment%2C%20multiple%20communication%20channels%20displayed%20on%20modern%20dashboard&width=700&height=500&seq=svc-followup-01&orientation=landscape',
    imageAlt: 'Automated follow-up sequences for home service lead conversion',
  },
  {
    number: '04',
    title: 'Pipeline Intelligence Dashboard',
    description:
      'Stop guessing and start knowing. Our dashboard gives you a live view of every lead, estimate, and job in your pipeline. See exactly where revenue stands, identify bottlenecks, and make confident decisions every single day.',
    features: [
      { text: 'Live lead and job status tracking' },
      { text: 'Revenue pipeline visibility' },
      { text: 'Conversion rate insights' },
      { text: 'Team performance metrics' },
    ],
    icon: 'ri-dashboard-3-line',
    reverse: true,
    bgClass: 'bg-[#F8FAFC]',
    imageUrl:
      'https://readdy.ai/api/search-image?query=professional%20business%20analytics%20dashboard%20on%20large%20monitor%20showing%20KPI%20metrics%20charts%20revenue%20data%20and%20pipeline%20statistics%2C%20clean%20modern%20office%20environment%2C%20data%20visualization%20for%20service%20business%20operations%2C%20bright%20professional%20workspace&width=700&height=500&seq=svc-dashboard-01&orientation=landscape',
    imageAlt: 'Pipeline visibility dashboard for home service business revenue tracking',
  },
];

export default function ServicesPage() {
  return (
    <div className="font-inter">
      <Navbar />
      <main>
        <ServicesHeader />

        <section className="bg-white py-16 border-b border-slate-100">
          <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
            <p className="text-slate-500 text-lg leading-relaxed">
              Omega Solutions AI replaces manual, error-prone processes with
              structured automation systems engineered to increase booked jobs
              and reduce operational chaos. From the moment a lead first
              contacts you to the day the job is closed and reviewed—everything
              runs automatically, consistently, and without anyone dropping the
              ball.
            </p>
          </div>
        </section>

        {serviceData.map((service) => (
          <ServiceDetail
            key={service.number}
            number={service.number}
            title={service.title}
            description={service.description}
            features={service.features}
            icon={service.icon}
            reverse={service.reverse}
            bgClass={service.bgClass}
            imageUrl={service.imageUrl}
            imageAlt={service.imageAlt}
          />
        ))}

        <SolarSection />
        <HowItWorks />
        <ServicesCTA />
      </main>
      <Footer />
    </div>
  );
}
